import { Box } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { isSelected, setSelected } from './Editor/editorSlice';
import FieldActions from './FieldActions';

/* eslint-disable jsx-a11y/click-events-have-key-events */
const Selectable = ({
  children, tabIndex = 99, id, index, hideActions = false,
}) => {
  const selected = useSelector((state) => isSelected(state, id));
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(setSelected(id));
  };

  const props = {};
  if (selected) {
    props.border = '2px solid';
    props.borderColor = 'blue.400';
  }

  return (
    <Box pos="relative" pt="8px">
      <Box {...props} onClick={handleClick} tabIndex={tabIndex}>
        {children}
      </Box>
      {!hideActions && selected && (
        <Box pos="absolute" top={0} right="8px" bg="#fcfcfc" px="4px">
          <FieldActions index={index} />
        </Box>
      )}
    </Box>
  );
};

export default Selectable;
